import { FunctionComponent } from 'react';
import { ProductType } from '@/types';
import { t } from '@/utils/i18n';
import { LoadingImage } from '@/components/common/LoadingImage';
import './SharingPreview.scss';

interface Props {
  productType: ProductType;
  id?: string;
  previewImageUrl?: string;
}

export const SharingPreview: FunctionComponent<Props> = ({ productType, id, previewImageUrl }) => {
  const sizes =
    productType.sizes.length > 1
      ? t(
          'share.sizes',
          productType.sizes[0].name,
          productType.sizes[productType.sizes.length - 1].name
        )
      : productType.sizes[0].name;
  const colors =
    productType.appearances.length > 1
      ? t('share.availableColors', productType.appearances.length.toFixed(0))
      : productType.appearances[0].name;
  return (
    <div className="sharing-preview">
      <div className="sharing-preview__image-wrapper">
        {previewImageUrl && (
          <LoadingImage
            className="sharing-preview__image"
            src={previewImageUrl}
            alt=""
            width="120"
            height="120"
          />
        )}
      </div>
      <div className="sharing-preview__product">
        <h4>{productType.name}</h4>
        <span className="sharing-preview__product-type">{sizes}</span>
        <span className="sharing-preview__product-type">{colors}</span>
        {id && <span className="sharing-preview__product-id">{`ID: ${id}`}</span>}
      </div>
    </div>
  );
};
